import type { CoachingGoal } from '@efdigital/ll-addon-data';
import GoalDetail from '@efdigital/ll-xceed-v2/components/coaching/goal-detail.gts';
import type CoachingCoacheeCohortGoalsGoalController from '@efdigital/ll-xceed-v2/controllers/coaching/coachee/cohort/goals/goal';
import type { CoachingCoacheeCohortGoalsGoalModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/goals/goal';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import { array } from '@ember/helper';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortGoalsGoalSignature {
  Args: {
    model: CoachingCoacheeCohortGoalsGoalModel;
    controller: CoachingCoacheeCohortGoalsGoalController;
  };
}

export default class CoachingCoacheeCohortGoalsGoal extends Component<CoachingCoacheeCohortGoalsGoalSignature> {
  authorship = (goal: CoachingGoal): string => {
    if (goal.createdByUserId === goal.user) {
      return 'You set this';
    }
    return 'Set by your coach';
  };

  <template>
    {{#if @model.goal}}
      {{pageTitle @model.goal.title}}

      <div class={{PAGE_WRAPPER}}>
        <GoalDetail
          @goal={{@model.goal}}
          @milestones={{@model.milestones}}
          @reflections={{@model.reflections}}
          @backRoute="coaching.coachee.cohort.goals"
          @backModels={{array @model.program_id @model.cohort_id}}
          @detailRoute="coaching.coachee.cohort.goals.goal"
          @detailModels={{array
            @model.program_id
            @model.cohort_id
            @model.goal.id
          }}
          @refreshRoute="coaching.coachee.cohort.goals"
          @role="coachee"
          @authorship={{this.authorship @model.goal}}
          @startInEdit={{@controller.startInEdit}}
        />
      </div>
    {{/if}}
  </template>
}
